import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "../../lib/utils";

export const Switch = React.forwardRef<
	React.ElementRef<typeof SwitchPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
	<SwitchPrimitive.Root
		ref={ref}
		className={cn(
			"peer inline-flex h-5 w-9 cursor-pointer items-center border border-[#2e665c] transition-colors data-[state=checked]:border-[#00ffcc] data-[state=checked]:bg-[#00ffcc12] data-[state=unchecked]:bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#00ffcc99] disabled:opacity-40",
			className,
		)}
		{...props}
	>
		<SwitchPrimitive.Thumb
			className={cn(
				"pointer-events-none block h-3 w-3 bg-[#8dbdb3] transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-1 data-[state=checked]:bg-[#00ffcc]",
			)}
		/>
	</SwitchPrimitive.Root>
));
Switch.displayName = "Switch";
